import * as React from "react";

function SvgComponent(props) {
  return <svg id="svg7384" style={{
    enableBackground: "new"
  }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><title id="title8473">{"Gnome Symbolic Icons"}</title><defs id="defs7386" /><g id="layer10" transform="translate(-51.9998,-192)" /><g id="layer1" transform="translate(-51.9998,-128)"><path d="m 52.4998,135 h 2.000203 c 0.276999,0 0.499999,0.223 0.499999,0.5 v 1 c 0,0.277 -0.223,0.5 -0.499999,0.5 H 52.4998 c -0.276999,0 -0.499998,-0.223 -0.499998,-0.5 v -1 c 0,-0.277 0.222999,-0.5 0.499998,-0.5 z" id="rect4906-43-6" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none",
        enableBackground: "new"
      }} /><path d="M 65.4998,135 H 67.5 c 0.276889,0 0.4998,0.223 0.4998,0.5 v 1 c 0,0.277 -0.222911,0.5 -0.4998,0.5 H 65.4998 C 65.222911,137 65,136.777 65,136.5 v -1 c 0,-0.277 0.222911,-0.5 0.4998,-0.5 z" id="rect4906-4-6-6" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none",
        enableBackground: "new"
      }} /><path d="m -61.240255,137.5928 h 2.000203 c 0.276999,0 0.499999,0.223 0.499999,0.5 v 1 c 0,0.277 -0.223,0.5 -0.499999,0.5 h -2.000203 c -0.276999,0 -0.499998,-0.223 -0.499998,-0.5 v -1 c 0,-0.277 0.222999,-0.5 0.499998,-0.5 z" id="rect8386" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none",
        enableBackground: "new"
      }} transform="rotate(-45)" /><path d="m -48.240255,137.5928 h 2.0002 c 0.276889,0 0.4998,0.223 0.4998,0.5 v 1 c 0,0.277 -0.222911,0.5 -0.4998,0.5 h -2.0002 c -0.276889,0 -0.4998,-0.223 -0.4998,-0.5 v -1 c 0,-0.277 0.222911,-0.5 0.4998,-0.5 z" id="rect8388" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none",
        enableBackground: "new"
      }} transform="rotate(-45)" /><path d="m -143.5,58.999832 h 2.0002 c 0.277,0 0.5,0.223 0.5,0.5 v 1 c 0,0.277 -0.223,0.5 -0.5,0.5 H -143.5 c -0.277,0 -0.5,-0.223 -0.5,-0.5 v -1 c 0,-0.277 0.223,-0.5 0.5,-0.5 z" id="rect8390" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none",
        enableBackground: "new"
      }} transform="rotate(-90)" /><path d="m -130.50002,58.999832 h 2.0002 c 0.27689,0 0.4998,0.223 0.4998,0.5 v 1 c 0,0.277 -0.22291,0.5 -0.4998,0.5 h -2.0002 c -0.27689,0 -0.4998,-0.223 -0.4998,-0.5 v -1 c 0,-0.277 0.22291,-0.5 0.4998,-0.5 z" id="rect8392" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none",
        enableBackground: "new"
      }} transform="rotate(-90)" /><path d="m -146.09281,-54.740238 h 2.00021 c 0.277,0 0.5,0.223 0.5,0.5 v 1 c 0,0.277 -0.223,0.5 -0.5,0.5 h -2.00021 c -0.27699,0 -0.49999,-0.223 -0.49999,-0.5 v -1 c 0,-0.277 0.223,-0.5 0.49999,-0.5 z" id="rect8394" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none",
        enableBackground: "new"
      }} transform="rotate(-135)" /><path d="m -133.09282,-54.740238 h 2.0002 c 0.27689,0 0.4998,0.223 0.4998,0.5 v 1 c 0,0.277 -0.22291,0.5 -0.4998,0.5 h -2.0002 c -0.27689,0 -0.4998,-0.223 -0.4998,-0.5 v -1 c 0,-0.277 0.22291,-0.5 0.4998,-0.5 z" id="rect8396" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none",
        enableBackground: "new"
      }} transform="rotate(-135)" /><g id="g3424" style={{
        opacity: 1
      }}><path d="m 64,136 c 0,2.20914 -1.790861,4 -4,4 -2.209139,0 -4,-1.79086 -4,-4 0,-2.20914 1.790861,-4 4,-4 2.209139,0 4,1.79086 4,4 z" id="path3426" style={{
          color: "#000000",
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: "normal",
          fontStretch: "normal",
          fontSize: "medium",
          lineHeight: "normal",
          fontFamily: "sans-serif",
          fontVariantLigatures: "normal",
          fontVariantPosition: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontVariantAlternates: "normal",
          fontVariantEastAsian: "normal",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          textIndent: 0,
          textAlign: "start",
          textDecoration: "none",
          textDecorationLine: "none",
          textDecorationStyle: "solid",
          textDecorationColor: "#000000",
          letterSpacing: "normal",
          wordSpacing: "normal",
          textTransform: "none",
          writingMode: "lr-tb",
          direction: "ltr",
          textOrientation: "mixed",
          dominantBaseline: "auto",
          baselineShift: "baseline",
          textAnchor: "start",
          whiteSpace: "normal",
          shapePadding: 0,
          shapeMargin: 0,
          inlineSize: 0,
          clipRule: "nonzero",
          display: "inline",
          overflow: "visible",
          visibility: "visible",
          isolation: "auto",
          mixBlendMode: "normal",
          colorInterpolation: "sRGB",
          colorInterpolationFilters: "linearRGB",
          solidColor: "#000000",
          solidOpacity: 1,
          vectorEffect: "none",
          fill: "#2e3436",
          fillOpacity: 1,
          fillRule: "nonzero",
          strokeWidth: 0.499999,
          strokeLinecap: "butt",
          strokeLinejoin: "round",
          strokeMiterlimit: 4,
          strokeDasharray: "none",
          strokeDashoffset: 0,
          strokeOpacity: 1,
          colorRendering: "auto",
          imageRendering: "auto",
          shapeRendering: "auto",
          textRendering: "auto",
          enableBackground: "new",
          stopColor: "#000000",
          stopOpacity: 1,
          stroke: "none"
        }} /><path d="M 60 131.75 C 57.655751 131.75 55.75 133.65575 55.75 136 C 55.75 138.34425 57.655751 140.25 60 140.25 C 62.344249 140.25 64.25 138.34425 64.25 136 C 64.25 133.65575 62.344249 131.75 60 131.75 z M 60 132.25 C 62.074029 132.25 63.75 133.92597 63.75 136 C 63.75 138.07403 62.074029 139.75 60 139.75 C 57.925971 139.75 56.25 138.07403 56.25 136 C 56.25 133.92597 57.925971 132.25 60 132.25 z " id="path3428" style={{
          color: "#000000",
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: "normal",
          fontStretch: "normal",
          fontSize: "medium",
          lineHeight: "normal",
          fontFamily: "sans-serif",
          fontVariantLigatures: "normal",
          fontVariantPosition: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontVariantAlternates: "normal",
          fontVariantEastAsian: "normal",
          fontFeatureSettings: "normal",
          fontVariationSettings: "normal",
          textIndent: 0,
          textAlign: "start",
          textDecoration: "none",
          textDecorationLine: "none",
          textDecorationStyle: "solid",
          textDecorationColor: "#000000",
          letterSpacing: "normal",
          wordSpacing: "normal",
          textTransform: "none",
          writingMode: "lr-tb",
          direction: "ltr",
          textOrientation: "mixed",
          dominantBaseline: "auto",
          baselineShift: "baseline",
          textAnchor: "start",
          whiteSpace: "normal",
          shapePadding: 0,
          shapeMargin: 0,
          inlineSize: 0,
          clipRule: "nonzero",
          display: "inline",
          overflow: "visible",
          visibility: "visible",
          isolation: "auto",
          mixBlendMode: "normal",
          colorInterpolation: "sRGB",
          colorInterpolationFilters: "linearRGB",
          solidColor: "#000000",
          solidOpacity: 1,
          vectorEffect: "none",
          fillOpacity: 1,
          fillRule: "nonzero",
          strokeWidth: 0.499999,
          strokeLinecap: "butt",
          strokeLinejoin: "round",
          strokeMiterlimit: 4,
          strokeDasharray: "none",
          strokeDashoffset: 0,
          strokeOpacity: 1,
          colorRendering: "auto",
          imageRendering: "auto",
          shapeRendering: "auto",
          textRendering: "auto",
          enableBackground: "new",
          stopColor: "#000000",
          stopOpacity: 1,
          stroke: "none"
        }} /></g></g><g id="layer11" transform="translate(-51.9998,-192)" /><g id="layer7" transform="translate(-51.9998,-128)" /><g id="layer6" transform="translate(-51.9998,-128)" /><g id="layer5" transform="translate(-51.9998,-128)" /><g id="layer9" transform="translate(-51.9998,-128)" /><g id="layer2" transform="translate(-51.9998,-128)" /><g id="layer8" transform="translate(-51.9998,-128)" /><g id="layer3" transform="translate(-51.9998,-128)" /><g id="layer4" transform="translate(-51.9998,-128)" /></svg>;
}

export default SvgComponent;